"use client";

import React from "react";
import type { Offering } from "@/lib/types/database/offerings";

interface OfferingDeliveryKitTabProps {
  item: Offering;
}

export function OfferingDeliveryKitTab({ item }: OfferingDeliveryKitTabProps) {
  if (!item.delivery_kit || item.delivery_kit.trim() === "") {
    return (
      <div className="p-6 text-center text-gray-500">
        <p>No delivery kit content yet.</p>
        <p className="mt-2 text-sm">This section contains internal instructions for engineers on how to execute the work.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="border rounded-lg p-6 bg-gray-50 dark:bg-gray-900">
        <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2 block">
          Internal Delivery Instructions
        </label>
        <div className="prose prose-sm max-w-none text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
          {item.delivery_kit}
        </div>
      </div>
    </div>
  );
}
